/**
 * @return {boolean}
 */
module.exports = function isLocalhost() {
    return window.location.hostname === "localhost";
}